(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["blitz-box-gallery"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('blitz-box-gallery')) {
  customElements.define('blitz-box-gallery', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.dialog = this.querySelector('dialog');
      this.slides = Array.from(this.querySelectorAll('[data-gallery-slide]'));
      this.index = 0;
      this.thumbs = this.slides.map((slide,index) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.dataset.galleryIndex = String(index);
        button.setAttribute('aria-label',slide.dataset.caption);
        const image = slide.querySelector('img').cloneNode();
        const url = new URL(image.src);
        url.searchParams.set('width','100');
        image.src = url.href;
        image.removeAttribute('srcset');
        image.removeAttribute('sizes');
        image.alt = '';
        button.append(image);
        this.querySelector('[data-gallery-thumbnails]').append(button);
        return button;
      });
      this.addEventListener('click',event => {
        const button = event.target.closest('button');
        if (!button) {
          if (event.target === this.dialog) {
            const rect = this.dialog.getBoundingClientRect();
            if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
          }
          return;
        }
        if (button.hasAttribute('data-gallery-open')) {
          this.show(0);
          this.dialog.showModal();
        } else if (button.hasAttribute('data-gallery-close')) {
          this.dialog.close();
        } else if (button.hasAttribute('data-gallery-step')) {
          this.show(this.index + Number(button.dataset.galleryStep));
        } else if (button.hasAttribute('data-gallery-index')) {
          this.show(Number(button.dataset.galleryIndex));
        }
      });
      this.dialog.addEventListener('keydown',event => {
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault();
          this.show(this.index + (event.key === 'ArrowRight' ? 1 : -1));
        }
      });
      this.dialog.addEventListener('close',() => this.querySelector('[data-gallery-open]').focus());
      this.show(0);
    }
    show(index) {
      if (!this.slides.length) return;
      this.index = (index + this.slides.length) % this.slides.length;
      this.slides.forEach((slide,i) => { slide.hidden = i !== this.index; });
      this.thumbs.forEach((thumb,i) => thumb.setAttribute('aria-current',String(i === this.index)));
      this.querySelector('[data-gallery-count]').textContent = (this.index + 1) + ' / ' + this.slides.length;
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["blitz-disp-gallery"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('blitz-disp-gallery')) {
  customElements.define('blitz-disp-gallery', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.dialog = this.querySelector('dialog');
      this.slides = Array.from(this.querySelectorAll('[data-gallery-slide]'));
      this.index = 0;
      this.thumbs = this.slides.map((slide,index) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.dataset.galleryIndex = String(index);
        button.setAttribute('aria-label',slide.dataset.caption);
        const image = slide.querySelector('img').cloneNode();
        const url = new URL(image.src);
        url.searchParams.set('width','100');
        image.src = url.href;
        image.removeAttribute('srcset');
        image.removeAttribute('sizes');
        image.alt = '';
        button.append(image);
        this.querySelector('[data-gallery-thumbnails]').append(button);
        return button;
      });
      this.addEventListener('click',event => {
        const button = event.target.closest('button');
        if (!button) {
          if (event.target === this.dialog) {
            const rect = this.dialog.getBoundingClientRect();
            if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
          }
          return;
        }
        if (button.hasAttribute('data-gallery-open')) {
          this.show(0);
          this.dialog.showModal();
        } else if (button.hasAttribute('data-gallery-close')) {
          this.dialog.close();
        } else if (button.hasAttribute('data-gallery-step')) {
          this.show(this.index + Number(button.dataset.galleryStep));
        } else if (button.hasAttribute('data-gallery-index')) {
          this.show(Number(button.dataset.galleryIndex));
        }
      });
      this.dialog.addEventListener('keydown',event => {
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault();
          this.show(this.index + (event.key === 'ArrowRight' ? 1 : -1));
        }
      });
      this.dialog.addEventListener('close',() => this.querySelector('[data-gallery-open]').focus());
      this.show(0);
    }
    show(index) {
      if (!this.slides.length) return;
      this.index = (index + this.slides.length) % this.slides.length;
      this.slides.forEach((slide,i) => { slide.hidden = i !== this.index; });
      this.thumbs.forEach((thumb,i) => thumb.setAttribute('aria-current',String(i === this.index)));
      this.querySelector('[data-gallery-count]').textContent = (this.index + 1) + ' / ' + this.slides.length;
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["blitz-ducto-gallery"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('blitz-ducto-gallery')) {
  customElements.define('blitz-ducto-gallery', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.dialog = this.querySelector('dialog');
      this.slides = Array.from(this.querySelectorAll('[data-gallery-slide]'));
      this.index = 0;
      this.thumbs = this.slides.map((slide,index) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.dataset.galleryIndex = String(index);
        button.setAttribute('aria-label',slide.dataset.caption);
        const image = slide.querySelector('img').cloneNode();
        const url = new URL(image.src);
        url.searchParams.set('width','100');
        image.src = url.href;
        image.removeAttribute('srcset');
        image.removeAttribute('sizes');
        image.alt = '';
        button.append(image);
        this.querySelector('[data-gallery-thumbnails]').append(button);
        return button;
      });
      this.addEventListener('click',event => {
        const button = event.target.closest('button');
        if (!button) {
          if (event.target === this.dialog) {
            const rect = this.dialog.getBoundingClientRect();
            if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
          }
          return;
        }
        if (button.hasAttribute('data-gallery-open')) {
          this.show(0);
          this.dialog.showModal();
        } else if (button.hasAttribute('data-gallery-close')) {
          this.dialog.close();
        } else if (button.hasAttribute('data-gallery-step')) {
          this.show(this.index + Number(button.dataset.galleryStep));
        } else if (button.hasAttribute('data-gallery-index')) {
          this.show(Number(button.dataset.galleryIndex));
        }
      });
      this.dialog.addEventListener('keydown',event => {
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault();
          this.show(this.index + (event.key === 'ArrowRight' ? 1 : -1));
        }
      });
      this.dialog.addEventListener('close',() => this.querySelector('[data-gallery-open]').focus());
      this.show(0);
    }
    show(index) {
      if (!this.slides.length) return;
      this.index = (index + this.slides.length) % this.slides.length;
      this.slides.forEach((slide,i) => { slide.hidden = i !== this.index; });
      this.thumbs.forEach((thumb,i) => thumb.setAttribute('aria-current',String(i === this.index)));
      this.querySelector('[data-gallery-count]').textContent = (this.index + 1) + ' / ' + this.slides.length;
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["blitz-equipment-gallery"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('blitz-equipment-gallery')) {
  customElements.define('blitz-equipment-gallery', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.dialog = this.querySelector('dialog');
      this.slides = Array.from(this.querySelectorAll('[data-gallery-slide]'));
      this.index = 0;
      this.thumbs = this.slides.map((slide,index) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.dataset.galleryIndex = String(index);
        button.setAttribute('aria-label',slide.dataset.caption);
        const image = slide.querySelector('img').cloneNode();
        const url = new URL(image.src);
        url.searchParams.set('width','100');
        image.src = url.href;
        image.removeAttribute('srcset');
        image.removeAttribute('sizes');
        image.alt = '';
        button.append(image);
        this.querySelector('[data-gallery-thumbnails]').append(button);
        return button;
      });
      this.addEventListener('click',event => {
        const button = event.target.closest('button');
        if (!button) {
          if (event.target === this.dialog) {
            const rect = this.dialog.getBoundingClientRect();
            if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
          }
          return;
        }
        if (button.hasAttribute('data-gallery-open')) {
          this.show(0);
          this.dialog.showModal();
        } else if (button.hasAttribute('data-gallery-close')) {
          this.dialog.close();
        } else if (button.hasAttribute('data-gallery-step')) {
          this.show(this.index + Number(button.dataset.galleryStep));
        } else if (button.hasAttribute('data-gallery-index')) {
          this.show(Number(button.dataset.galleryIndex));
        }
      });
      this.dialog.addEventListener('keydown',event => {
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault();
          this.show(this.index + (event.key === 'ArrowRight' ? 1 : -1));
        }
      });
      this.dialog.addEventListener('close',() => this.querySelector('[data-gallery-open]').focus());
      this.show(0);
    }
    show(index) {
      if (!this.slides.length) return;
      this.index = (index + this.slides.length) % this.slides.length;
      this.slides.forEach((slide,i) => { slide.hidden = i !== this.index; });
      this.thumbs.forEach((thumb,i) => thumb.setAttribute('aria-current',String(i === this.index)));
      this.querySelector('[data-gallery-count]').textContent = (this.index + 1) + ' / ' + this.slides.length;
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["blitz-filament-gallery"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('blitz-filament-gallery')) {
  customElements.define('blitz-filament-gallery', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.dialog = this.querySelector('dialog');
      this.slides = Array.from(this.querySelectorAll('[data-gallery-slide]'));
      this.index = 0;
      this.thumbs = this.slides.map((slide,index) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.dataset.galleryIndex = String(index);
        button.setAttribute('aria-label',slide.dataset.caption);
        const image = slide.querySelector('img').cloneNode();
        const url = new URL(image.src);
        url.searchParams.set('width','100');
        image.src = url.href;
        image.removeAttribute('srcset');
        image.removeAttribute('sizes');
        image.alt = '';
        button.append(image);
        this.querySelector('[data-gallery-thumbnails]').append(button);
        return button;
      });
      this.addEventListener('click',event => {
        const button = event.target.closest('button');
        if (!button) {
          if (event.target === this.dialog) {
            const rect = this.dialog.getBoundingClientRect();
            if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
          }
          return;
        }
        if (button.hasAttribute('data-gallery-open')) {
          this.show(0);
          this.dialog.showModal();
        } else if (button.hasAttribute('data-gallery-close')) {
          this.dialog.close();
        } else if (button.hasAttribute('data-gallery-step')) {
          this.show(this.index + Number(button.dataset.galleryStep));
        } else if (button.hasAttribute('data-gallery-index')) {
          this.show(Number(button.dataset.galleryIndex));
        }
      });
      this.dialog.addEventListener('keydown',event => {
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault();
          this.show(this.index + (event.key === 'ArrowRight' ? 1 : -1));
        }
      });
      this.dialog.addEventListener('close',() => this.querySelector('[data-gallery-open]').focus());
      this.show(0);
    }
    show(index) {
      if (!this.slides.length) return;
      this.index = (index + this.slides.length) % this.slides.length;
      this.slides.forEach((slide,i) => { slide.hidden = i !== this.index; });
      this.thumbs.forEach((thumb,i) => thumb.setAttribute('aria-current',String(i === this.index)));
      this.querySelector('[data-gallery-count]').textContent = (this.index + 1) + ' / ' + this.slides.length;
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["blitz-kit-gallery"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('blitz-kit-gallery')) {
  customElements.define('blitz-kit-gallery', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.dialog = this.querySelector('dialog');
      this.slides = Array.from(this.querySelectorAll('[data-gallery-slide]'));
      this.index = 0;
      this.thumbs = this.slides.map((slide,index) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.dataset.galleryIndex = String(index);
        button.setAttribute('aria-label',slide.dataset.caption);
        const image = slide.querySelector('img').cloneNode();
        const url = new URL(image.src);
        url.searchParams.set('width','100');
        image.src = url.href;
        image.removeAttribute('srcset');
        image.removeAttribute('sizes');
        image.alt = '';
        button.append(image);
        this.querySelector('[data-gallery-thumbnails]').append(button);
        return button;
      });
      this.addEventListener('click',event => {
        const button = event.target.closest('button');
        if (!button) {
          if (event.target === this.dialog) {
            const rect = this.dialog.getBoundingClientRect();
            if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
          }
          return;
        }
        if (button.hasAttribute('data-gallery-open')) {
          this.show(0);
          this.dialog.showModal();
        } else if (button.hasAttribute('data-gallery-close')) {
          this.dialog.close();
        } else if (button.hasAttribute('data-gallery-step')) {
          this.show(this.index + Number(button.dataset.galleryStep));
        } else if (button.hasAttribute('data-gallery-index')) {
          this.show(Number(button.dataset.galleryIndex));
        }
      });
      this.dialog.addEventListener('keydown',event => {
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault();
          this.show(this.index + (event.key === 'ArrowRight' ? 1 : -1));
        }
      });
      this.dialog.addEventListener('close',() => this.querySelector('[data-gallery-open]').focus());
      this.show(0);
    }
    show(index) {
      if (!this.slides.length) return;
      this.index = (index + this.slides.length) % this.slides.length;
      this.slides.forEach((slide,i) => { slide.hidden = i !== this.index; });
      this.thumbs.forEach((thumb,i) => thumb.setAttribute('aria-current',String(i === this.index)));
      this.querySelector('[data-gallery-count]').textContent = (this.index + 1) + ' / ' + this.slides.length;
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["blitz-marcaje-gallery"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('blitz-marcaje-gallery')) {
  customElements.define('blitz-marcaje-gallery', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.dialog = this.querySelector('dialog');
      this.slides = Array.from(this.querySelectorAll('[data-gallery-slide]'));
      this.index = 0;
      this.thumbs = this.slides.map((slide,index) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.dataset.galleryIndex = String(index);
        button.setAttribute('aria-label',slide.dataset.caption);
        const image = slide.querySelector('img').cloneNode();
        const url = new URL(image.src);
        url.searchParams.set('width','100');
        image.src = url.href;
        image.removeAttribute('srcset');
        image.removeAttribute('sizes');
        image.alt = '';
        button.append(image);
        this.querySelector('[data-gallery-thumbnails]').append(button);
        return button;
      });
      this.addEventListener('click',event => {
        const button = event.target.closest('button');
        if (!button) {
          if (event.target === this.dialog) {
            const rect = this.dialog.getBoundingClientRect();
            if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
          }
          return;
        }
        if (button.hasAttribute('data-gallery-open')) {
          this.show(0);
          this.dialog.showModal();
        } else if (button.hasAttribute('data-gallery-close')) {
          this.dialog.close();
        } else if (button.hasAttribute('data-gallery-step')) {
          this.show(this.index + Number(button.dataset.galleryStep));
        } else if (button.hasAttribute('data-gallery-index')) {
          this.show(Number(button.dataset.galleryIndex));
        }
      });
      this.dialog.addEventListener('keydown',event => {
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault();
          this.show(this.index + (event.key === 'ArrowRight' ? 1 : -1));
        }
      });
      this.dialog.addEventListener('close',() => this.querySelector('[data-gallery-open]').focus());
      this.show(0);
    }
    show(index) {
      if (!this.slides.length) return;
      this.index = (index + this.slides.length) % this.slides.length;
      this.slides.forEach((slide,i) => { slide.hidden = i !== this.index; });
      this.thumbs.forEach((thumb,i) => thumb.setAttribute('aria-current',String(i === this.index)));
      this.querySelector('[data-gallery-count]').textContent = (this.index + 1) + ' / ' + this.slides.length;
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["blitz-masking-gallery"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('blitz-masking-gallery')) {
  customElements.define('blitz-masking-gallery', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.dialog = this.querySelector('dialog');
      this.slides = Array.from(this.querySelectorAll('[data-gallery-slide]'));
      this.index = 0;
      this.thumbs = this.slides.map((slide,index) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.dataset.galleryIndex = String(index);
        button.setAttribute('aria-label',slide.dataset.caption);
        const image = slide.querySelector('img').cloneNode();
        const url = new URL(image.src);
        url.searchParams.set('width','100');
        image.src = url.href;
        image.removeAttribute('srcset');
        image.removeAttribute('sizes');
        image.alt = '';
        button.append(image);
        this.querySelector('[data-gallery-thumbnails]').append(button);
        return button;
      });
      this.addEventListener('click',event => {
        const button = event.target.closest('button');
        if (!button) {
          if (event.target === this.dialog) {
            const rect = this.dialog.getBoundingClientRect();
            if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
          }
          return;
        }
        if (button.hasAttribute('data-gallery-open')) {
          this.show(0);
          this.dialog.showModal();
        } else if (button.hasAttribute('data-gallery-close')) {
          this.dialog.close();
        } else if (button.hasAttribute('data-gallery-step')) {
          this.show(this.index + Number(button.dataset.galleryStep));
        } else if (button.hasAttribute('data-gallery-index')) {
          this.show(Number(button.dataset.galleryIndex));
        }
      });
      this.dialog.addEventListener('keydown',event => {
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault();
          this.show(this.index + (event.key === 'ArrowRight' ? 1 : -1));
        }
      });
      this.dialog.addEventListener('close',() => this.querySelector('[data-gallery-open]').focus());
      this.show(0);
    }
    show(index) {
      if (!this.slides.length) return;
      this.index = (index + this.slides.length) % this.slides.length;
      this.slides.forEach((slide,i) => { slide.hidden = i !== this.index; });
      this.thumbs.forEach((thumb,i) => thumb.setAttribute('aria-current',String(i === this.index)));
      this.querySelector('[data-gallery-count]').textContent = (this.index + 1) + ' / ' + this.slides.length;
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["blitz-product-gallery"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('blitz-product-gallery')) {
  customElements.define('blitz-product-gallery', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.dialog = this.querySelector('dialog');
      this.slides = Array.from(this.querySelectorAll('[data-gallery-slide]'));
      this.index = 0;
      this.thumbs = this.slides.map((slide,index) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.dataset.galleryIndex = String(index);
        button.setAttribute('aria-label',slide.dataset.caption);
        const image = slide.querySelector('img').cloneNode();
        const url = new URL(image.src);
        url.searchParams.set('width','100');
        image.src = url.href;
        image.removeAttribute('srcset');
        image.removeAttribute('sizes');
        image.alt = '';
        button.append(image);
        this.querySelector('[data-gallery-thumbnails]').append(button);
        return button;
      });
      this.addEventListener('click',event => {
        const button = event.target.closest('button');
        if (!button) {
          if (event.target === this.dialog) {
            const rect = this.dialog.getBoundingClientRect();
            if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
          }
          return;
        }
        if (button.hasAttribute('data-gallery-open')) {
          this.show(0);
          this.dialog.showModal();
        } else if (button.hasAttribute('data-gallery-close')) {
          this.dialog.close();
        } else if (button.hasAttribute('data-gallery-step')) {
          this.show(this.index + Number(button.dataset.galleryStep));
        } else if (button.hasAttribute('data-gallery-index')) {
          this.show(Number(button.dataset.galleryIndex));
        }
      });
      this.dialog.addEventListener('keydown',event => {
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault();
          this.show(this.index + (event.key === 'ArrowRight' ? 1 : -1));
        }
      });
      this.dialog.addEventListener('close',() => this.querySelector('[data-gallery-open]').focus());
      this.show(0);
    }
    show(index) {
      if (!this.slides.length) return;
      this.index = (index + this.slides.length) % this.slides.length;
      this.slides.forEach((slide,i) => { slide.hidden = i !== this.index; });
      this.thumbs.forEach((thumb,i) => thumb.setAttribute('aria-current',String(i === this.index)));
      this.querySelector('[data-gallery-count]').textContent = (this.index + 1) + ' / ' + this.slides.length;
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["blitz-pvc-gallery"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('blitz-pvc-gallery')) {
  customElements.define('blitz-pvc-gallery', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.dialog = this.querySelector('dialog');
      this.slides = Array.from(this.querySelectorAll('[data-gallery-slide]'));
      this.index = 0;
      this.thumbs = this.slides.map((slide,index) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.dataset.galleryIndex = String(index);
        button.setAttribute('aria-label',slide.dataset.caption);
        const image = slide.querySelector('img').cloneNode();
        const url = new URL(image.src);
        url.searchParams.set('width','100');
        image.src = url.href;
        image.removeAttribute('srcset');
        image.removeAttribute('sizes');
        image.alt = '';
        button.append(image);
        this.querySelector('[data-gallery-thumbnails]').append(button);
        return button;
      });
      this.addEventListener('click',event => {
        const button = event.target.closest('button');
        if (!button) {
          if (event.target === this.dialog) {
            const rect = this.dialog.getBoundingClientRect();
            if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
          }
          return;
        }
        if (button.hasAttribute('data-gallery-open')) {
          this.show(0);
          this.dialog.showModal();
        } else if (button.hasAttribute('data-gallery-close')) {
          this.dialog.close();
        } else if (button.hasAttribute('data-gallery-step')) {
          this.show(this.index + Number(button.dataset.galleryStep));
        } else if (button.hasAttribute('data-gallery-index')) {
          this.show(Number(button.dataset.galleryIndex));
        }
      });
      this.dialog.addEventListener('keydown',event => {
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault();
          this.show(this.index + (event.key === 'ArrowRight' ? 1 : -1));
        }
      });
      this.dialog.addEventListener('close',() => this.querySelector('[data-gallery-open]').focus());
      this.show(0);
    }
    show(index) {
      if (!this.slides.length) return;
      this.index = (index + this.slides.length) % this.slides.length;
      this.slides.forEach((slide,i) => { slide.hidden = i !== this.index; });
      this.thumbs.forEach((thumb,i) => thumb.setAttribute('aria-current',String(i === this.index)));
      this.querySelector('[data-gallery-count]').textContent = (this.index + 1) + ' / ' + this.slides.length;
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["blitz-sealer-gallery"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('blitz-sealer-gallery')) {
  customElements.define('blitz-sealer-gallery', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.dialog = this.querySelector('dialog');
      this.slides = Array.from(this.querySelectorAll('[data-gallery-slide]'));
      this.index = 0;
      this.thumbs = this.slides.map((slide,index) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.dataset.galleryIndex = String(index);
        button.setAttribute('aria-label',slide.dataset.caption);
        const image = slide.querySelector('img').cloneNode();
        image.loading = 'eager';
        image.removeAttribute('srcset');
        image.removeAttribute('sizes');
        image.alt = '';
        button.append(image);
        this.querySelector('[data-gallery-thumbnails]').append(button);
        return button;
      });
      this.addEventListener('click',event => {
        const button = event.target.closest('button');
        if (!button) {
          if (event.target === this.dialog) {
            const rect = this.dialog.getBoundingClientRect();
            if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
          }
          return;
        }
        if (button.hasAttribute('data-gallery-open') || button.hasAttribute('data-gallery-sheet')) {
          this.opener = button;
          this.show(button.hasAttribute('data-gallery-sheet') ? this.slides.length - 1 : 0);
          this.dialog.showModal();
        } else if (button.hasAttribute('data-gallery-close')) {
          this.dialog.close();
        } else if (button.hasAttribute('data-gallery-step')) {
          this.show(this.index + Number(button.dataset.galleryStep));
        } else if (button.hasAttribute('data-gallery-index')) {
          this.show(Number(button.dataset.galleryIndex));
        }
      });
      this.dialog.addEventListener('keydown',event => {
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault();
          this.show(this.index + (event.key === 'ArrowRight' ? 1 : -1));
        }
      });
      this.dialog.addEventListener('close',() => (this.opener || this.querySelector('[data-gallery-open]')).focus());
      this.show(0);
    }
    show(index) {
      if (!this.slides.length) return;
      this.index = (index + this.slides.length) % this.slides.length;
      this.slides.forEach((slide,i) => { slide.hidden = i !== this.index; });
      this.thumbs.forEach((thumb,i) => thumb.setAttribute('aria-current',String(i === this.index)));
      this.querySelector('[data-gallery-count]').textContent = (this.index + 1) + ' / ' + this.slides.length;
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
